export enum AuthorityEnum {
  ADMIN = 'ROLE_ADMIN',
  MODERATOR = 'ROLE_MODERATOR',
  USER = 'ROLE_USER',
}
